
import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { NgbDropdownConfig, NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { CentrosMantencionService } from '../../../services/centralization/centros-mantencion.service';
import { dutchRangeLabel } from '../../../shared/dutchRangeLabel';
import { NgxSpinnerService } from "ngx-spinner";
import { EditarConfirmarComponent } from '../../modals/centralizacion-remuneraciones/editar-confirmar/editar-confirmar.component';
import { CrearNuevoCentroComponent } from '../../modals/centralizacion-remuneraciones/crear-nuevo-centro/crear-nuevo-centro.component';
import { EditarCentroComponent } from '../../modals/centralizacion-remuneraciones/editar-centro/editar-centro.component';
import { Centro } from '../../../interface/cost-center/centro.interface';
import { PipesModule } from '../../../shared/pipes';
import { Router, RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-cost-center',
  imports: [CommonModule,
    ReactiveFormsModule,
    RouterLink,
    MatTableModule,
    MatPaginatorModule,
    NgbDropdownModule,
    PipesModule],
  templateUrl: './cost-center.component.html',
  styleUrl: './cost-center.component.css'
})
export class CostCenterComponent {

  filtrosForm: FormGroup;
  centroEstados: any = [
    { name: 'Activo', value: 1 },
    { name: 'Inactivo', value: 0 },

  ];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  displayedColumns: any[] = [
    'centId',
    'centNombreCentro',
    'centSociedad',
    'centSegmento',
    'centAnalistaFinanzas',
    //'centCentroCosto',
    'centActivado',
    'centroOpciones'
  ];
  pageSize = 5;
  pageSizeOptions = [5, 10, 25, 50];
  totalRows = 0;
  centros: any = [];
  centrosFiltrados: any;
  sociedades: any[] = [];


  constructor(
    private readonly _formBuilder: FormBuilder,
    private readonly _modalService: NgbModal,
    private readonly _centrosService: CentrosMantencionService,
    private readonly _toastr: ToastrService,
    private readonly _cdr: ChangeDetectorRef,
    private readonly _spinner: NgxSpinnerService,
    private readonly _router: Router,
    config: NgbDropdownConfig
  ) {
    this.filtrosForm = this._formBuilder.group({
      centNombreCentro: [''],
      centId: [''],
      centActivado: [null]
    });
    config.placement = 'bottom-end';
  }
  ngOnInit(): void {
    this.listarCentros(0, this.pageSize);
    this.dataSource.filterPredicate = (data, filter) => {
      return data.centNombreCentro.toLowerCase().includes(filter);
    };
    this.obtenerSociedadesYSegmentos();
  }
  ngAfterViewInit() {
    this.paginator._intl.itemsPerPageLabel = 'Filas por página';
    this.paginator._intl.nextPageLabel = 'Página Siguiente';
    this.paginator._intl.previousPageLabel = 'Página Anterior';
    this.paginator._intl.getRangeLabel = dutchRangeLabel;
    this.dataSource.paginator = this.paginator;
    this.paginator.page.subscribe(() => {
      this.listarCentros(this.paginator.pageIndex, this.paginator.pageSize);
    });
  }

  abrirModalCrearCentro() {
    const modalRef = this._modalService.open(CrearNuevoCentroComponent, { backdrop: 'static', centered: true });
    modalRef.componentInstance.sociedades = this.sociedades;
    modalRef.result.then(
      (result) => {
        console.log('Modal cerrado con resultado:', result);
        if (result) {
          const confirmModalRef = this._modalService.open(EditarConfirmarComponent, { backdrop: 'static' });
          confirmModalRef.componentInstance.titulo = 'Crear Centro';
          confirmModalRef.componentInstance.texto = `¿Está seguro de querer crear el Centro: “${result.centNombreCentro}”?`;
          confirmModalRef.result.then(
            (confirmResult) => {
              console.log('Modal de confirmación cerrado con resultado:', confirmResult);
              if (confirmResult) {
                this.crearCentro(result);
              }
            },
            (reason) => {
              console.log('Modal de confirmación cerrado por:', reason);
            }
          );
        }
      },
      (reason) => {
        console.log('Modal cerrado por:', reason);
      }
    );
  }

  abrirModalEditarCentro(element: any) {
    console.log('element', element);
    const modalRef = this._modalService.open(EditarCentroComponent, { backdrop: 'static', centered: true });
    modalRef.componentInstance.centroDatos = element;
    modalRef.componentInstance.sociedades = this.sociedades;
    modalRef.result.then(
      (result) => {
        console.log('Modal cerrado con resultado:', result);
        if (result) {
          const confirmModalRef = this._modalService.open(EditarConfirmarComponent, { backdrop: 'static' });
          confirmModalRef.componentInstance.titulo = 'Editar Centro';
          confirmModalRef.componentInstance.texto = `¿Está seguro de querer editar el Centro: “${result.centNombreCentro}”?`;

          confirmModalRef.result.then(
            (confirmResult) => {
              if (confirmResult) {
                //console.log("Datos enviados a editarCentro:", result);
                this.editarCentro(result);
              }
            },
            (reason) => {
              console.log('Modal cerrado por:', reason);
            }
          );
        }
      },
      (reason) => {
        console.log('Modal cerrado por:', reason);
      }
    );
  }
  editarCentro(centro: any) {
    this._spinner.show();
    const currentUser = localStorage.getItem('currentUserCr');
    const userName = currentUser ? JSON.parse(currentUser).us_nombres : null;
    const body = {
      ...centro,
      centActivado: centro.centActivado ? 1 : 0,
      centUpdateAt: new Date().toISOString(),
      centUpdateFor: userName,
    };
    //console.log("Body enviado al backend:", body);
    this._centrosService.editarCentro(body).subscribe({
      next: (res: any) => {
        console.log('response:', res);
        this.listarCentros(0, this.pageSize);
        this._toastr.success('Centro actualizado correctamente.', 'Éxito');
        this._spinner.hide();
      },
      error: (err: any) => {
        console.log('error:', err);
        this._spinner.hide();
        this._toastr.warning('Ocurrió un error al intentar actualizar el centro. Intente más tarde o contacte a soporte.', 'Error');
      }
    });
  }


  listarCentros(offset?: any, limit?: any) {
    this._spinner.show();
    if (!limit && !offset) {
      limit = this.paginator.pageSize;
      offset = this.paginator.pageIndex;
    }
    const filtros = this.filtrosForm.value;
    const centNombreCentro = filtros.centNombreCentro || '';
    const centCodigoCompania = filtros.centId || '';
    const centActivado: boolean | undefined = filtros.centActivado !== null ? filtros.centActivado === 1 : undefined;
    //console.log('Valor de centActivado:', centActivado);
    this._centrosService.listarCentroMantenedor(limit, offset, centNombreCentro, centCodigoCompania, centActivado).subscribe({
      next: (res: any) => {
        console.log('Respuesta del servicio:', res);
        this.centrosFiltrados = res.rows
        this.dataSource = new MatTableDataSource(this.centrosFiltrados);
        this.totalRows = res.count;
        this.paginator.length = this.totalRows;
        this.paginator.pageSize = limit;
        this._spinner.hide();
        this._spinner.hide();
      },
      error: (error) => {
        this._spinner.hide();
        console.error('Error al listar los centros:', error);
        this._toastr.warning('Error al cargar los centros.', 'Error');
      }
    });
  }

  crearCentro(nuevoCentro: Centro) {
    this._spinner.show();
    let userName = null;
    let userId = null;
    const currentUser = localStorage.getItem('currentUserCr');
    if (currentUser) {
      const parsedUser = JSON.parse(currentUser);
      userName = parsedUser.us_nombres;
      userId = parsedUser.us_id;
      //console.log('userName:', userName);
    }
    const currentDateTime = new Date();
    const adjustedDateTime = new Date(currentDateTime.getTime() - 3 * 60 * 60 * 1000).toISOString();

    console.log(adjustedDateTime);
    const centroConDatosAdicionales = {
      ...nuevoCentro,
      centCreateFor: userName,
      centActivado: nuevoCentro.centActivado ? 1 : 0,
      centCreateAt: adjustedDateTime,
      centUpdateAt: adjustedDateTime,
    };
    console.log("centroConDatosAdicionales", centroConDatosAdicionales)
    this._centrosService.agregarCentroMantenedor(centroConDatosAdicionales).subscribe({
      next: (res) => {
        this.listarCentros(0, this.pageSize);
        console.log('Centro creado exitosamente:', res);
        this._toastr.success('Centro creado con éxito', 'Éxito');
        this._spinner.hide();
      },
      error: (error) => {
        this._spinner.hide();
        console.error('Error al crear el centro:', error);
        this._toastr.warning('Hubo un error al crear el centro', 'Error');
      }
    });
  }

  aplicarFiltros(): void {
    this.listarCentros(0, this.pageSize);
    console.log('this.pageSize', this.pageSize)
  }

  limpiarFiltros(): void {
    this.filtrosForm.reset({
      centActivado: null,
      centNombreCentro: '',
      centId: '',

    });
    this.pageSize = 5;
    this.listarCentros();
  }


  validarAlfanumerico(event: Event): void {
    const input = event.target as HTMLInputElement;
    const valor = input.value;
    const valorValidado = valor.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚ ]/g, '');
    if (valor !== valorValidado) {
      input.value = valorValidado;
      this.filtrosForm.controls['procesoNombre'].setValue(valorValidado);
    }
  }

  obtenerSociedadesYSegmentos(): void {
    this._centrosService.listarSociedadesYSegmentos().subscribe({
      next: (data) => {
        console.log('Sociedades y segmentos:', data);
        this.sociedades = data;
        console.log('this.sociedades', this.sociedades)
      },
      error: (err) => {
        console.error('Error al obtener sociedades y segmentos:', err);
      }
    });
  }
  cancelar(): void {
    this._router.navigate(['/process-list']);
  }
}
